import angular from 'angular';
import eventBus from 'pubsub-js';
import SignalRService from '@/shared/services/SignalRService';

angular.module('cloudX').factory('authService', [
  '$q',
  '$timeout',
  'authServiceConfig',
  function($q, $timeout, config) {
    var self = this;
    self.user = config.user;
    self.manager = config.manager;
    self.events = {
      onLogout: [],
      onNewToken: [],
    };

    //debugger;
    if (!self.user)
      self.manager.getUser().then(function(user) {
        self.user = user;
      });

    self.manager.events.addUserLoaded(function(user) {
      if (user) angular.extend(self.user, user);
      notifyListeners(self.events.onNewToken, user.access_token, user.profile);
    });

    function isLoggedIn() {
      return self.user != null && !self.user.expired;
    }

    function getClaims() {
      return self.user ? self.user.profile : null;
    }

    function getAuthorizationHeaderValue() {
      return self.user ? self.user.token_type + ' ' + self.user.access_token : null;
    }

    function getToken() {
      return self.user ? self.user.access_token : null;
    }
    function getUserId() {
      return self.user ? self.user.profile.Sid : null;
    }
    function startAuthentication() {
      return self.manager.signinRedirect({
        state: {
          url: window.location.href,
        },
      });
    }

    function completeAuthentication() {
      return self.manager.signinRedirectCallback().then(function(user) {
        self.user = user;
      });
    }

    function notifyListeners(listeners) {
      var args = Array.prototype.slice.call(arguments, 1);
      return $q.all(
        listeners.map(function(fnc) {
          return $q.when(fnc.apply(null, args));
        }),
      );
    }

    function logOut() {
      return notifyListeners(self.events.onLogout).finally(function() {
        cleanupSessionStorage();
        SignalRService.stopConnection();

        self.manager.signoutRedirect();
      });
    }

    function addEventListener(event) {
      return function(callback) {
        if (typeof callback === 'function') event.push(callback);
      };
    }

    function signinSilent() {
      self.manager.signinSilent().then(user => {
        if (user) angular.extend(self.user, user);
        notifyListeners(self.events.onNewToken, user.access_token, user.profile);
      });
    }

    function cleanupSessionStorage() {
      if (!sessionStorage) return;
      var i = sessionStorage.length;
      while (i--) {
        var key = sessionStorage.key(i);
        // Keep the authentication token, the identity ms still needs it to logout
        if (key.indexOf('oidc.user:') !== 0) {
          sessionStorage.removeItem(key);
        }
      }
    }

    // can be triggered when silent login was request and performed from react screen
    eventBus.subscribe('signinSilentCompleted', function(msg, user) {
      $timeout(function() {
        if (user) angular.extend(self.user, user);
        notifyListeners(self.events.onNewToken, user.access_token, user.profile);
      }, 100);
    });

    return {
      isLoggedIn: isLoggedIn,
      getClaims: getClaims,
      getToken: getToken,
      getAuthorizationHeaderValue: getAuthorizationHeaderValue,
      startAuthentication: startAuthentication,
      completeAuthentication: completeAuthentication,
      logOut: logOut,
      addOnLogOut: addEventListener(self.events.onLogout),
      addOnNewToken: addEventListener(self.events.onNewToken),
      signinSilent: signinSilent,
      getUserId: getUserId,
    };
  },
]);
